import { useState, useEffect } from 'react';
import { useGetLatestMessageMutation, useWhatsAppSessionMutation } from '../api/chatApi';
import { setSession } from '../../auth/slices/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setLatestMessage } from '../slices/chatSlice';
import { formatedDateAndTime } from '../../../utils/helpers';
import Logout from './Logout';
import { useSocket } from '../../../contexts/SocketContext';
import UploadModal from './UploadModal';

const Header = ({selectedId, setProfileModal}) => {
  const {latestMessage} = useSelector((state) => state.chat);
  const { session } = useSelector((state) => state.auth);
  const [profilePic, setProfilePic] = useState(null);
  const [logoutModal, setLogoutModal] = useState(false);
  const [uploadStatusModal, setUploadStatusModal] = useState(false);
  const [lastAccountSyncTimestamp, setLastAccountSyncTimestamp] = useState(null);
  const [whatsAppSessionApi] = useWhatsAppSessionMutation();
  const [getLatestMsgApi] = useGetLatestMessageMutation();
  const dispatch = useDispatch();
   const socket = useSocket();

  const fetchWhatsAppSession = async () => {
    try {
      const response = await whatsAppSessionApi({ id: selectedId }).unwrap();
      if (response.success) {
        const { session, profile } = response.data;
        if (session) {
          dispatch(setSession(session))
        };
        setProfilePic(profile || "/avatar.jpeg");
        
      }
    } catch (error) {
      setProfilePic(null)
    }
  };

  const fetchLatestMessage = async() => {
    try {
      const response = await getLatestMsgApi({ id: selectedId }).unwrap();
      const data = response?.data;
      if (data) {
        dispatch(setLatestMessage(data.latestMessage));
        setLastAccountSyncTimestamp(data.timestamp);
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    fetchWhatsAppSession();
    fetchLatestMessage();
  }, []);

  useEffect(() => {
    if (!socket || !selectedId) return;

    const handleIncomingMessage = ({ employeeId, msgObj: message }) => {
      if (employeeId !== selectedId) return;

      dispatch(setLatestMessage(message));
    };

    const handleUpdateProfile = ({ employeeId, session}) => {
      if (employeeId !== selectedId) return;
      
      dispatch(setSession(session))
    }

    socket.on('message-received', handleIncomingMessage);
    socket.on('profile-update', handleUpdateProfile);
    return () => {
      socket.off('message-received', handleIncomingMessage);
      socket.off('profile-update', handleUpdateProfile)
    };
  }, [socket, selectedId])

  const handleLogout = async() => {
    setLogoutModal(true);
  };

  return (
    <div style={{ padding: '10px', borderBottom: '0.3px solid rgb(219 197 197)', backgroundColor:'#fff', position:'sticky', top:'0', zIndex: '9'}}>
      <div className='header-section'>
        {/* <div className='logo-section'> */}
          <div className='section'>
            <img id='logo' src='/chat.png' alt='' title='Chats'/>
          </div>
        {/* </div> */}
        <div style={{ position: 'relative', display: 'flex', gap: '20px', alignItems: 'center' }}>
          {session && 
            <div style={{ color: '#000', fontWeight: '500', fontSize: '12px'}}>
              <p>{session.push_name} - ({session.phone_number})</p>
              <p><strong>Last Sync:-</strong> {latestMessage ? formatedDateAndTime(latestMessage?.createdAt) : formatedDateAndTime(session?.createdAt)}</p>
              {/* {lastAccountSyncTimestamp && <p><strong>Last Sync:-</strong> {formatFullDateTime(lastAccountSyncTimestamp)}</p>} */}
            </div>
          }
          {/* <div className='section'>
            <img id='logo' src='/upload.png' alt='' title='Upload status' onClick={() => setUploadStatusModal(true)}/>
          </div> */}

          {/* logout option */}
          <img src='/logout.png' alt="logout" style={styles.icon} onClick={handleLogout}/>
          <div className="section">
            <img src={profilePic} alt='' onClick={() => setProfileModal(true)}/>
          </div>
        </div>
      </div>

      {logoutModal && 
        <Logout 
          onClose={() => setLogoutModal(false)} 
          session={session} 
        />
      }

      {uploadStatusModal && 
        <UploadModal 
          onClose={() => setUploadStatusModal(false)} 
          session={session} 
        />
      }
    </div>
  );
};

export default Header;

const styles = {
  menu: {
    position: 'absolute',
    top: '60px',
    right: '60px',
    background: '#fff',
    color: '#333',
    borderRadius: '8px',
    boxShadow: '0 0 8px rgba(0,0,0,0.2)',
    overflow: 'hidden',
    zIndex: 99999,
    minWidth: '120px'
  },
  menuItem: {
    padding: '10px 15px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee',
    display: 'flex',
    alignItems: 'center',
  },

  icon: {
    width: '18px',
    height: '18px',
    marginRight: '4px',
    cursor: 'pointer'
  },
  
  menuText: {
    fontSize: '14px',
  }
};
